import React, { useState } from "react"
import PropTypes from "prop-types"

import { Formik } from "formik"
import { Form, Button } from "react-bootstrap"

import BusinessHourModal from "./BusinessHourModal"
import Icon from "../../Utils/Icon"
import dayOfWeeks from "../../Utils/day_of_week"
import { RequestHandler } from "../../Utils/request_handler"

import * as styles from "./Styles/Information.module.scss"
import "../../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

import { FormErrors, InformationProps } from "./types"
import { displayClosingTime } from "../../Utils/business_hour"

const BusinessHours = ({ businessHours, holiday, index, error, ...props }) => {
  const hasAllday = businessHours.find((h) => !h.openingTime)
  const messages = (): Array<string | Element> => {
    const messages = []
    if (holiday) {
      messages.push("定休日")
    }
    if (hasAllday) {
      messages.push("24時間営業")
    }
    businessHours.forEach((hours) => {
      if (hours.openingTime) {
        const closingTime = displayClosingTime(
          hours.openingTime,
          hours.closingTime
        )
        messages.push(`${hours.openingTime}~${closingTime}`)
      }
    })
    if (messages.length == 0) {
      messages.push("営業時間を入力する")
    }
    return messages
  }

  return (
    <div className={styles.businessHour}>
      <div className="l-flex" key={index}>
        <div className={styles.innerSectionLeft}>{dayOfWeeks[index]}</div>
        <div className={styles.innerSectionRight}>
          <a href="#" onClick={props.onClick}>
            {messages()
              .map((m, i) => <span key={i}>{m}</span>)
              .reduce(
                (prev, next): any =>
                  prev && next ? [prev, " / ", next] : [next],
                null
              )}
            <Icon
              className={styles.editIcon}
              type="feather"
              name="edit"
              attr={{ width: 14, height: 14 }}
            />
          </a>
        </div>
      </div>
      {error && (
        <div className={cn("invalid-feedback", "invalidBusinessHour")}>
          {error}
        </div>
      )}
    </div>
  )
}

const FileInput = (props) => {
  const [image, setImage] = useState(props.place.image)
  const checkIsCache = () => image.match("data")

  const handleChange = (e) => {
    const reader = new FileReader()
    reader.onload = () => {
      setImage(reader.result)
    }
    reader.readAsDataURL(e.target.files[0])
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!image) {
      return
    }
    const handler = new RequestHandler(
      (document.getElementById("adminPlace.image") as HTMLFormElement).action,
      "POST",
      { image: image }
    )
    const res = await handler.requestWithBody()
    if (res.status != 200) {
      alert("更新に失敗しました。時間を置いてもう一度お試しください。")
    }
    if (res.body.location) {
      document.location = res.body.location
    }
  }
  const handleRemove = async (e) => {
    e.preventDefault()
    if (checkIsCache()) {
      return setImage(null)
    }
    if (!window.confirm("画像を削除しますか？")) {
      return
    }

    const handler = new RequestHandler(
      (document.getElementById("adminPlace.image") as HTMLFormElement).action,
      "POST",
      { image: null }
    )
    const res = await handler.requestWithBody()
    if (res.status != 200) {
      alert("更新に失敗しました。時間を置いてもう一度お試しください。")
    }
    if (res.body.location) {
      document.location = res.body.location
    }
  }

  return (
    <React.Fragment>
      <Form
        id="adminPlace.image"
        noValidate
        action={props.params.imageUploadPath}
        method="POST"
        onSubmit={handleSubmit}
      >
        <Form.Group controlId="adminPlace.image.form">
          <div className={cn("l-flex", "sectionWrapper")}>
            <div className={styles.sectionLeft}>
              <Form.Label>外観写真</Form.Label>
              <div className={styles.annotation}>
                推奨サイズ: 1280*1280px
                <br />
                10MB以内 / jpg, png
              </div>
            </div>
            <div className={cn("sectionRight--image")}>
              {image && (
                <div className={styles.imagePreview}>
                  <a
                    href="#"
                    onClick={handleRemove}
                    className={styles.removeLink}
                  >
                    <Icon
                      className={styles.removeIcon}
                      type="feather"
                      name="x-circle"
                      attr={{ width: 24, height: 24 }}
                    />
                  </a>
                  <img
                    id="adminPlaceForm.image.preview"
                    className={styles.placeImage}
                    src={image}
                  />
                </div>
              )}
              <div className={cn("l-flex", "imageControls")}>
                <Form.File
                  name="image"
                  className={styles.fileSelector}
                  onChange={handleChange}
                  label="ファイルを選択"
                  data-browse=""
                  custom
                />
                <Button className="l-primary-button--admin" type="submit">
                  保存する
                </Button>
              </div>
            </div>
          </div>
          <input
            type="hidden"
            name="authenticity_token"
            value={props.params.token}
          />
        </Form.Group>
      </Form>
    </React.Fragment>
  )
}

const handleSubmit = async (values, setErrors) => {
  const handler = new RequestHandler("", "PUT", { place: values })
  const res = await handler.requestWithBody()
  if (res.status != 200) {
    if (!res.body.errors || !res.body.errors.place) {
      alert(
        `更新に失敗しました。時間を置いてもう一度お試しください。\n${res.body.errors.others}`
      )
    }
    setErrors(res.body.errors.place || {})
    return
  }
  if (res.body.location) {
    document.location = res.body.location
  }
}

const PlaceInformation: React.FC<InformationProps> = (props) => {
  const [currentModalWday, setModalWday] = useState(null)
  const [currentErrors, setErrors] = useState({} as FormErrors)

  return (
    <React.Fragment>
      <div className="l-section-background--admin">
        <FileInput {...props} />
      </div>
      <div className="l-section-background--admin">
        <Formik
          onSubmit={async (values) => await handleSubmit(values, setErrors)}
          initialValues={props.place}
        >
          {({ handleSubmit, handleChange, handleBlur, values, touched }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Group controlId="adminPlace.url">
                <div className={cn("l-flex", "sectionWrapper")}>
                  <div className={styles.sectionLeft}>
                    <Form.Label>公式ホームページのURL</Form.Label>
                  </div>
                  <div className={styles.sectionRight}>
                    <Form.Control
                      type="text"
                      placeholder="https://..."
                      name="url"
                      value={values.url}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={!!currentErrors.url}
                    />
                    <Form.Control.Feedback type="invalid">
                      {currentErrors.url}
                    </Form.Control.Feedback>
                  </div>
                </div>
              </Form.Group>
              <Form.Group controlId="adminPlace.description">
                <div className={cn("l-flex", "sectionWrapper")}>
                  <div className={styles.sectionLeft}>
                    <Form.Label>備考</Form.Label>
                  </div>
                  <div className={styles.sectionRight}>
                    <Form.Control
                      type="text"
                      name="description"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={!!currentErrors.description}
                      as="textarea"
                      rows={5}
                    />
                    <Form.Control.Feedback type="invalid">
                      {currentErrors.description}
                    </Form.Control.Feedback>
                  </div>
                </div>
              </Form.Group>
              <hr className={styles.separator} />
              <div className={cn("l-flex", "sectionWrapper")}>
                <div className={styles.sectionLeft}>
                  <label>営業時間・定休日</label>
                </div>
                <div className={styles.sectionRight}>
                  <React.Fragment>
                    {Object.keys(dayOfWeeks).map((index) => (
                      <BusinessHours
                        key={index}
                        index={index}
                        businessHours={values.businessHours.filter(
                          (h) => h.dayOfWeek == index
                        )}
                        holiday={values.holidays.find(
                          (h) => h.dayOfWeek == index
                        )}
                        error={
                          currentErrors.businessHours
                            ? currentErrors.businessHours[index]
                            : null
                        }
                        onClick={() => setModalWday(index)}
                      />
                    ))}
                    <Form.Group controlId="adminPlaceForm.businessHourAnnotation">
                      <Form.Control
                        as="textarea"
                        placeholder="備考"
                        name="businessHourAnnotation"
                        value={values.businessHourAnnotation || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Form.Group>
                  </React.Fragment>
                </div>
              </div>
              <BusinessHourModal
                wday={currentModalWday}
                holidays={values.holidays}
                businessHours={values.businessHours}
                onChange={handleChange}
                onHide={() => setModalWday(null)}
                touched={touched}
              />

              <input
                type="hidden"
                name="authenticity_token"
                value={props.params.token}
              />
              <div className="l-flex">
                <div className={styles.sectionLeft}></div>
                <div className={cn("sectionRight", "sectionRight--button")}>
                  <Button
                    className="l-primary-button--admin"
                    variant="primary"
                    type="submit"
                  >
                    保存する
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </React.Fragment>
  )
}
PlaceInformation.propTypes = {
  params: PropTypes.any,
  place: PropTypes.any,
}
export default PlaceInformation
